import { LegalProtectionSummaryPanel } from 'features/subscription-process/legal-protection/LegalProtectionSummaryPanel';
import { LEGAL_PROTECTION_ROUTES } from 'features/subscription-process/utils/legalProtectionRoutes';
import { NsKey } from 'enums/NsKey';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { usePanel } from 'hooks/usePanel';
import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuoteContractualizationData } from '../../store';

/**
 * "Risk" panel of the PJ contractualisation: the read-only summary of the folder (company,
 * subsidiaries, cumulated figures). Any change goes back to the company step, where the
 * eligibility is recomputed.
 *
 * The company comes from the contractualisation data, like the coproperty of the MRI: the panel
 * is rendered by the overlay, outside the subscription process provider, and the process does
 * not return the risk data once a quote is contractualised.
 */
export const LegalProtectionRisk: FC = () => {
  const { t } = useDynamicTranslation([NsKey.Contractualization]);
  const quoteData = useQuoteContractualizationData();
  const navigate = useNavigate();
  const { closePanel } = usePanel();

  const riskId = quoteData?.riskId;
  const company = quoteData?.company;

  const goToCompanyStep = useCallback(() => {
    closePanel();
    navigate(`${LEGAL_PROTECTION_ROUTES.registration}/${riskId}`);
  }, [closePanel, navigate, riskId]);

  if (!company || !riskId) {
    return <p className="text-sm text-gray-500">{t('CONTRACTUALIZATION.LEGAL_PROTECTION.NO_COMPANY')}</p>;
  }

  return <LegalProtectionSummaryPanel company={company} riskId={riskId} onEditStep={goToCompanyStep} />;
};
